export default __webpack_public_path__ + "static/media/vendor.b24a5cff.svg";